<template>
    <div :id="this.$route.name">
        <Card back>
            <template v-slot:header>
                <h4 class="d-inline">حکم حقوقی</h4>
                <hr />
            </template>
            <template v-slot:btnCustome>
                <button class="btn btn-sm btn-info float-left" @click="GetHistory(DataAxios.Id)"> کلیه سوابق حکم حقوقی
                </button>
            </template>
            <template v-slot:content>
                <form autocomplete="off">
                    <div class="row">
                        <div class="col-md-8 col-12">
                            <small id="LblSalaryBasic"> حقوق پایه (ماهانه) </small>
                            <input type="text" dir="ltr" class="form-control InputText required"
                                v-model="DataAxios.SalaryBasic" @keypress="$ValidNumber($event, 15)"
                                @keyup="DataAxios.SalaryBasic = $PutCommatoInput_New($event)" />
                        </div>
                        <div class="col-md-4 col-12">
                            <button class="btn btn-secondary mt-4" @click.prevent="GetDefaultSalaryValues"> مشاهده مقادیر
                                حقوق و دستمزد سال </button>
                        </div>
                    </div>
                    <hr>
                    <div>مزایــا </div>
                    <div class="row mt-2">
                        <div class="col-md-4 col-12">
                            <small id="LblChild"> حق اولاد </small>
                            <input type="text" dir="ltr" @keypress="$ValidNumber($event, 15)"
                                @keyup="DataAxios.Child = $PutCommatoInput_New($event)"
                                class="form-control InputText required" v-model="DataAxios.Child" />
                        </div>
                        <div class="col-md-4 col-12">
                            <small id="LblHome"> حق مسکن </small>
                            <input type="text" dir="ltr" @keypress="$ValidNumber($event, 15)"
                                @keyup="DataAxios.Home = $PutCommatoInput_New($event)"
                                class="form-control InputText required" v-model="DataAxios.Home" />
                        </div>
                        <div class="col-md-4 col-12">
                            <small id="LblBone"> حق بن </small>
                            <input type="text" dir="ltr" @keypress="$ValidNumber($event, 15)"
                                @keyup="DataAxios.Bone = $PutCommatoInput_New($event)"
                                class="form-control InputText required" v-model="DataAxios.Bone" />
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-md-4 col-12">
                            <small id="LblSanavat"> پایه سنوات </small>
                            <input type="text" dir="ltr" @keypress="$ValidNumber($event, 15)"
                                @keyup="DataAxios.Sanavat = $PutCommatoInput_New($event)"
                                class="form-control InputText required" v-model="DataAxios.Sanavat" />
                        </div>
                        <div class="col-md-4 col-12">
                            <small id="LblSkill"> مهارت </small>
                            <input type="text" dir="ltr" @keypress="$ValidNumber($event, 15)"
                                @keyup="DataAxios.Skill = $PutCommatoInput_New($event)" class="form-control InputText "
                                v-model="DataAxios.Skill" />
                        </div>
                        <div class="col-md-4 col-12">
                            <small id="LblResponsibility"> حق مسئولیت </small>
                            <input type="text" dir="ltr" @keypress="$ValidNumber($event, 15)"
                                @keyup="DataAxios.Responsibility = $PutCommatoInput_New($event)"
                                class="form-control InputText " v-model="DataAxios.Responsibility" />
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-md-4 col-12">
                            <small id="LblEducation"> حق تحصیلات </small>
                            <input type="text" dir="ltr" @keypress="$ValidNumber($event, 15)"
                                @keyup="DataAxios.Education = $PutCommatoInput_New($event)" class="form-control InputText "
                                v-model="DataAxios.Education" />
                        </div>
                        <div class="col-md-4 col-12">
                            <small id="LblAmazing"> فوق العاده </small>
                            <input type="text" dir="ltr" @keypress="$ValidNumber($event, 15)"
                                @keyup="DataAxios.Amazing = $PutCommatoInput_New($event)" class="form-control InputText "
                                v-model="DataAxios.Amazing" />
                        </div>
                        <div class="col-md-4 col-12">
                            <small id="LblHageJazb"> حق جذب</small>
                            <input type="text" dir="ltr" @keypress="$ValidNumber($event, 15)"
                                @keyup="DataAxios.HageJazb = $PutCommatoInput_New($event)" class="form-control InputText "
                                v-model="DataAxios.HageJazb" />
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-md-4 col-12">
                            <small id="LblHageShift"> حق شیفت </small>
                            <input type="text" dir="ltr" @keypress="$ValidNumber($event, 15)"
                                @keyup="DataAxios.HageShift = $PutCommatoInput_New($event)" class="form-control InputText "
                                v-model="DataAxios.HageShift" />
                        </div>
                        <div class="col-md-4 col-12">
                            <small id="LblHardWork"> سختی کار </small>
                            <input type="text" dir="ltr" @keypress="$ValidNumber($event, 15)"
                                @keyup="DataAxios.HardWork = $PutCommatoInput_New($event)" class="form-control InputText "
                                v-model="DataAxios.HardWork" />
                        </div>
                        <div class="col-md-4 col-12">
                            <small id="LblFood"> حق غذا </small>
                            <input type="text" dir="ltr" @keypress="$ValidNumber($event, 15)"
                                @keyup="DataAxios.Food = $PutCommatoInput_New($event)" class="form-control InputText "
                                v-model="DataAxios.Food" />
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-md-4 col-12">
                            <small id="LblCashier"> صندوقدار </small>
                            <input type="text" dir="ltr" @keypress="$ValidNumber($event, 15)"
                                @keyup="DataAxios.Cashier = $PutCommatoInput_New($event)" class="form-control InputText "
                                v-model="DataAxios.Cashier" />
                        </div>
                        <div class="col-md-4 col-12">
                            <small id="LblTransportation"> ایاب و ذهاب </small>
                            <input type="text" dir="ltr" @keypress="$ValidNumber($event, 15)"
                                @keyup="DataAxios.Transportation = $PutCommatoInput_New($event)"
                                class="form-control InputText " v-model="DataAxios.Transportation" />
                        </div>
                        <div class="col-md-4 col-12">
                            <small id="LblOtherBenefits"> سایر مزایا </small>
                            <input type="text" dir="ltr" @keypress="$ValidNumber($event, 15)"
                                @keyup="DataAxios.OtherBenefits = $PutCommatoInput_New($event)"
                                class="form-control InputText " v-model="DataAxios.OtherBenefits" />
                        </div>
             
                    </div>
                    <div class="row mt-2">
                        <div class="col-md-4 col-12">
                            <small id="LblHagheTaahol">حق تاهل</small>
                            <input type="text" dir="ltr" @keypress="$ValidNumber($event, 15)"
                                @keyup="DataAxios.HagheTaahol = $PutCommatoInput_New($event)"
                                class="form-control InputText " v-model="DataAxios.HagheTaahol" />
                        </div>
                    </div>
                    <hr>
                    <div>کســورات </div>
                    <div class="row mt-2">
                        <div class="col-md-3 col-12">
                            <small id="LblBimeTakmily"> بیمه تکمیلی </small>
                            <input type="text" dir="ltr" @keypress="$ValidNumber($event, 15)"
                                @keyup="DataAxios.BimeTakmily = $PutCommatoInput_New($event)"
                                class="form-control InputText " v-model="DataAxios.BimeTakmily" />
                        </div>
                        <div class="col-md-3 col-12">
                            <small id="LblSahmBimeShodePercent"> درصد سهم بیمه شده </small>
                            <input type="text" dir="ltr" @keypress="$ValidNumber($event, 3)"
                                @keyup="DataAxios.SahmBimeShodePercent = $PutCommatoInput_New($event)"
                                class="form-control InputText required" v-model="DataAxios.SahmBimeShodePercent" />
                        </div>
                        <div class="col-md-3 col-12">
                            <small id="LblBimeBikaryPercent"> درصد بیمه بیکاری </small>
                            <input type="text" dir="ltr" @keypress="$ValidNumber($event, 3)"
                                @keyup="DataAxios.BimeBikaryPercent = $PutCommatoInput_New($event)"
                                class="form-control InputText required" v-model="DataAxios.BimeBikaryPercent" />
                        </div>
                        <div class="col-md-3 col-12">
                            <small id="LblSahmeKarFarmaPercent"> درصد سهم کارفرما </small>
                            <input type="text" dir="ltr" @keypress="$ValidNumber($event, 3)"
                                @keyup="DataAxios.SahmeKarFarmaPercent = $PutCommatoInput_New($event)"
                                class="form-control InputText required" v-model="DataAxios.SahmeKarFarmaPercent" />
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-md-3 col-12">
                            <small id="LblBakhshNameKasreBimeAzMaliatGrp24"> بخشنامه کسر بیمه از مالیات </small>
                            <SearchableCombo :edit="false" :code="null" :grp="24"
                                @ResultCombo="GetBakhshNameKasreBimeAzMaliatGrp24"
                                :defaultvalue="DataAxios.BakhshNameKasreBimeAzMaliatGrp24" :rownumintable="3"
                                :action="'TblSalaryCombo/GetComboById'" :method="'POST'"
                                :idinput="'BakhshNameKasreBimeAzMaliatGrp24'" :keyItem="'BakhshNameKasreBimeAzMaliatGrp24'"
                                :ClassProps="'required'"> </SearchableCombo>
                        </div>
                        <div class="col-md-3 col-12">
                            <small id="LblKasreBimeTakmilyAzMaliatGrp25"> بخشنامه کسر بیمه تکمیلی از مالیات </small>
                            <SearchableCombo :edit="false" :code="null" :grp="25"
                                @ResultCombo="GetKasreBimeTakmilyAzMaliatGrp25"
                                :defaultvalue="DataAxios.KasreBimeTakmilyAzMaliatGrp25" :rownumintable="3"
                                :action="'TblSalaryCombo/GetComboById'" :method="'POST'"
                                :idinput="'KasreBimeTakmilyAzMaliatGrp25'" :keyItem="'KasreBimeTakmilyAzMaliatGrp25'"
                                :ClassProps="'required'"> </SearchableCombo>
                        </div>
                        <div class="col-md-3 col-12">
                            <small id="LblDorePardakhtEidi"> دوره پرداخت عیدی (ماه) </small>
                            <input type="text" dir="ltr" @keypress="$ValidNumber($event, 2)"
                                @keyup="DataAxios.DorePardakhtEidi = $PutCommatoInput_New($event)"
                                class="form-control InputText " v-model="DataAxios.DorePardakhtEidi" />
                        </div>
                        <div class="col-md-3 col-12">
                            <small id="LblMaliatSabetPercent"> درصد مالیات ثابت </small> <span
                                class="fad fa-info mx-2 text-info Pointer"
                                title="برای مشاغلی که طبق پلکان مالیات نمی دهند"></span>
                            <input type="text" dir="ltr" @keypress="$ValidNumber($event, 3)"
                                @keyup="DataAxios.MaliatSabetPercent = $PutCommatoInput_New($event)"
                                class="form-control InputText " v-model="DataAxios.MaliatSabetPercent" />
                        </div>
                    </div>
                    <hr>
                    <div class="row">

                        <div class="mt-3">
                            <small id="LblRule7BarabarBasicSalary"> اعمال قانون رعایت مشمولیت سقف 7 برابر حداقل حقوق در
                                بیمه</small>
                            <div class="custom-control custom-switch text-right">
                                <input type="checkbox" checked class="custom-control-input InputText"
                                    id="Rule7BarabarBasicSalary" v-model="DataAxios.Rule7BarabarBasicSalary" />
                                <label class="custom-control-label" for="Rule7BarabarBasicSalary"> </label>
                            </div>
                        </div>

                        <div class="mt-3 mx-5">
                            <small id="LblMashmoleBime">مشمول بیمه</small>
                            <div class="custom-control custom-switch text-right">
                                <input type="checkbox" checked class="custom-control-input InputText" id="MashmoleBime"
                                    v-model="DataAxios.MashmoleBime" @change="changeMashmoleBime" />
                                <label class="custom-control-label" for="MashmoleBime"> </label>
                            </div>
                        </div>

                    </div>
                </form>
                <hr />
                <button v-if="Status == 'Add'" class="btn btn-success mr-5" @click.prevent="SaveDeta()">ثبت حکم
                    حقوقی</button>
                <button v-if="Status == 'Edit'" class="btn btn-success mr-5" @click.prevent="SaveEditDeta()">ویرایش حکم
                    حقوقی</button>

                <button id="btnCancel" class="btn btn-warning m-2" @click.prevent="Cancel()">انصراف</button>

                <Modal v-if="$store.state.Modal && modal1 == true" :InheritanceTheme="true" :IsFooter="false" :Size="'Md'">
                    <template v-slot:body>
                        <tab :tab="Tablist">
                            <template v-slot:content0>
                                <div class="row m-4">
                                    <table class="table table-bordered table-hover  text-center">
                                        <thead>
                                            <tr>
                                                <th scope="col">#</th>
                                                <th scope="col">نام آیتم حقوقی</th>
                                                <th scope="col">مشمولیت</th>
                                                <th scope="col">مقدار</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <th scope="row">1</th>
                                                <td>حقوق ماهانه </td>
                                                <td>هیچکدام</td>
                                                <td>{{ $Comma3ragham(Result.SalaryMonth) }}</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">3</th>
                                                <td>حق بن</td>
                                                <td>هیچکدام</td>
                                                <td>{{ $Comma3ragham(Result.Bone) }}</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">4</th>
                                                <td>حق مسکن </td>
                                                <td>هیچکدام</td>
                                                <td>{{ $Comma3ragham(Result.Home) }}</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">6</th>
                                                <td>پایه سنوات</td>
                                                <td>هیچکدام</td>
                                                <td>{{ $Comma3ragham(Result.Sanavat) }}</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">7</th>
                                                <td>حق اولاد</td>
                                                <td>هیچکدام</td>
                                                <td>{{ $Comma3ragham(Result.Child) }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <button class="btn btn-success m-5 w-100" @click.prevent="SaveCalculateSalary()">اعمال
                                        در حکم حقوقی</button>

                                </div>
                            </template>
                            <template v-slot:content1>
                                <div class="row m-4">
                                    <table class="table table-bordered table-hover  text-center">
                                        <thead>
                                            <tr>
                                                <th scope="col">#</th>
                                                <th scope="col">مبلغ حقوق از </th>
                                                <th scope="col">مبلغ حقوق تا </th>
                                                <th scope="col">درصد مالیات</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in ResultTblTaxLadder " :key="index">
                                                <th scope="row">{{ index + 1 }}</th>
                                                <td>{{ $Comma3ragham(item.Az) }}</td>
                                                <td>{{ $Comma3ragham(item.Ta) }}</td>
                                                <td>{{ item.Tax }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </template>
                        </tab>
                    </template>

                </Modal>
                <Modal v-if="$store.state.Modal && modal2 == true" :InheritanceTheme="true" :IsFooter="false" :Size="'Md'">
                    <template v-slot:body>
                        <div v-if="groupBy != null" class="row">
                            <div class="col-md-12 col-12">
                                <b-dropdown size="md" variant="link" class="d-inline text-center"
                                    toggle-class="text-decoration-none " title="تاریخ های ویرایش" no-caret>
                                    <template #button-content>
                                        <button class="btn btn-danger border" type="button"><i
                                                class="fas fa-filter"></i>تاریخ های ویرایش</button>
                                    </template>
                                    <b-dropdown-item v-for="(item, index) in Object.keys(groupBy)" :key="index" href="#"
                                        @click="GetDetailHistory(item)" class="text-center">{{ item }}
                                    </b-dropdown-item>
                                </b-dropdown>
                            </div>

                        </div>
                        <div v-else class="row m-2">
                            <div class="col-md-12 col-12 ">
                                <div class="alert alert-warning  text-center">درحال حاضر هیچ سوابقی در این حکم حقوقی وجود
                                    ندارد</div>
                            </div>
                        </div>
                        <div class="row m-2">
                            <div class="col-md-12 col-12">
                                <BnpGrid v-if="$store.state.renderComponentGrid" :propsColumn="Column" :propsRows="rows"
                                    :hasRowNum="true" :Sortable="true">

                                </BnpGrid>
                            </div>
                        </div>
                    </template>

                </Modal>
            </template>
        </Card>
    </div>
</template>
<script>
import Card from '@/components/Card/Card.vue';
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
import Modal from '@/pages/Modal/Modal.vue';
import Tab from '@/components/Tab/Tab.vue'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
export default {
    data() {
        return {
            rows: [],
            tempLegalRuling: [],
            Column: [
                {
                    name: 'TblBnpCashLogId',
                    label: 'TblBnpCashLogId',
                    visibility: false,
                },
                {
                    name: 'FieldCaption',
                    label: 'فیلد تغییر یافته',
                    visibility: true,
                },
                {
                    name: 'OldValue',
                    label: 'مقدارقدیم',
                    visibility: true,
                },
                {
                    name: 'NewValue',
                    label: 'مقدار جدید',
                    visibility: true,
                },
                {
                    name: 'ZamanLog',
                    label: 'تاریخ تغییر',
                    visibility: true,
                },
            ],
            DataAxios: { SahmBimeShodePercent: 7, BimeBikaryPercent: 3, SahmeKarFarmaPercent: 20, DorePardakhtEidi: 12 },
            modal1: false,
            modal2: false,
            Result: {},
            ResultTblTaxLadder: {},
            Status: '',
            DataAxiosPost: {
                ArryfildValue: {},
                Method: 'post',
                Action: '',
                Token: this.$session.get('Token'),
                From: 'Body',
            },
            DataAxiosUpdate: {
                ArryfildValue: {},
                Method: 'put',
                Action: '',
                Token: this.$session.get('Token'),
                From: 'Body',
            },
            Tablist: [{ header: 'مقادیر حکم حقوقی' }, { header: 'جدول پلکان مالیات' }]
            , groupBy: null
        };
    },
    components: { Card, SearchableCombo, Modal, Tab, BnpGrid },
    methods: {


        changeMashmoleBime() {
            if (this.DataAxios.MashmoleBime) {
                this.DataAxios.SahmBimeShodePercent = 7;
                this.DataAxios.BimeBikaryPercent = 3;
                this.DataAxios.SahmeKarFarmaPercent = 20;
            } else {
                this.DataAxios.SahmBimeShodePercent = 0;
                this.DataAxios.BimeBikaryPercent = 0;
                this.DataAxios.SahmeKarFarmaPercent = 0;
            }
        },

        GetDefaultSalaryValues() {
            var DataAxois = {
                ArryfildValue: {}, Method: 'Get', Action: 'SalaryServices/DefaultSalaryValues/false', Token: this.$session.get('Token'),
            };
            this.$PostData(DataAxois).then((data) => {
                if (data != null) {
                    if (data.IsSuccess == true) {
                        // console.log(data);
                        if (data.Data.Year == this.$store.state.JalaliDate.substring(0, 4))
                            this.Result = data.Data
                    }
                }
            }).finally(() => {
                var DataAxoisGetTblTaxLadder = {
                    ArryfildValue: {}, Method: 'Get', Action: 'SalaryServices/GetTblTaxLadder/false', Token: this.$session.get('Token'),
                };
                this.$PostData(DataAxoisGetTblTaxLadder).then((data) => {
                    if (data != null) {
                        if (data.IsSuccess == true) {
                            if (data.Data[0].Year == this.$store.state.JalaliDate.substring(0, 4))
                                this.ResultTblTaxLadder = data.Data
                        }
                    }
                }).finally(() => {
                    this.modal1 = true
                    this.$store.state.Modal = true
                })

            });
        },
        SaveCalculateSalary() {
            this.DataAxios.SalaryBasic = this.Result.SalaryMonth
            this.DataAxios.Bone = this.Result.Bone
            this.DataAxios.Home = this.Result.Home
            this.DataAxios.Sanavat = this.Result.Sanavat
            this.DataAxios.Child = this.Result.Child
            this.modal1 = false
            this.$store.state.Modal = false
        },


        GetBakhshNameKasreBimeAzMaliatGrp24(data) {
            if (data.id != null) {
                this.DataAxios.BakhshNameKasreBimeAzMaliatGrp24 = data.id
            }
        },
        GetKasreBimeTakmilyAzMaliatGrp25(data) {
            if (data.id != null) {
                this.DataAxios.KasreBimeTakmilyAzMaliatGrp25 = data.id
            }
        },
        GetDorePardakhtEidi(data) {
            if (data.id != null) {
                this.DataAxios.DorePardakhtEidi = data.id
            }
        },
        SaveDeta() {
            if (this.$ValidForm(this.$route.name)) {
                this.DataAxiosPost.Action = 'LegalRuling'
                this.DataAxiosPost.ArryfildValue = this.DataAxios
                this.$PostData(this.DataAxiosPost).then((data) => {
                    if (data.IsSuccess == true) {
                        this.$toasted.success('حکم حقوقی با موفقیت ایجاد شد', {
                            action: {
                                text: 'بستن',
                                onClick: (e, toastObject) => {
                                    toastObject.goAway(0)
                                },
                            },
                        })
                        this.Cancel()
                    }
                    else {
                        if (data.IsSuccess == false) {
                            this.$mySweetDefaultTost('خطایی رخ داده!', data.Message, 'error', 3000)
                        }
                    }
                })
            }
        },
        SaveEditDeta() {
            this.DataAxiosUpdate.Action = 'LegalRuling'
            this.DataAxiosUpdate.ArryfildValue = this.DataAxios
            this.$PutData_Body(this.DataAxiosUpdate).then((data) => {
                if (data.IsSuccess == true) {
                    this.$SetLog(this.DataAxios, 0)
                    this.$toasted.success('اطلاعات حکم حقوقی با موفقیت تغییر یافت', {
                        action: {
                            text: 'بستن',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0)
                            },
                        },
                    })
                    this.Cancel()
                } else {
                    if (data.IsSuccess == false) {
                        this.$mySweetDefaultTost('خطایی رخ داده!', data.Message, 'error', 3000)
                    }
                }
            })
        },
        Cancel() {
            this.$router.go(-1)
        },
        GetHistory(data) {
            // console.log(data);
            var DataAxois = {
                ArryfildValue: {}, Method: 'Get', Action: 'LegalRuling/GetHistory/' + data, Token: this.$session.get('Token'),
            };
            this.$PostData(DataAxois).then((data) => {
                if (data != null) {
                    if (data.IsSuccess == true) {
                        this.groupBy = this.groupByField(data.Data, 'ZamanLog');
                    }
                }
            }).finally(() => {
                this.modal2 = true
                this.$store.state.Modal = true
            })
        },
        groupByField(treeArray, field) {
            var result = {};
            for (var i = 0; i < treeArray.length; i++) {
                var node = treeArray[i];
                var fieldValue = node[field];
                if (!result[fieldValue]) { result[fieldValue] = []; }
                result[fieldValue].push(node);
            }
            return result;
        },
        GetDetailHistory(item) {
            let info = []
            this.rows = []
            info.push(this.groupBy[item])

            for (let index = 0; index < info.length; index++) {
                const element = info[index];
                this.rows = element
            }
            this.$store.state.renderComponentGrid = false
            this.$nextTick(() => {
                this.$store.state.renderComponentGrid = true
            })
        }
    },
    beforeMount() {
        var id = this.$route.params.DataRow.id
        var DataAxois = {
            ArryfildValue: {}, Method: 'Get', Action: 'LegalRuling/' + id, Token: this.$session.get('Token'),
        };
        this.$PostData(DataAxois).then((data) => {
            if (data != null) {
                if (data.IsSuccess == true && data.Data != null) {
                    this.Status = 'Edit'
                    this.DataAxios = data.Data
                    this.DataAxios.PersonnelId = this.$route.params.DataRow.id
                    this.DataAxios.TblUserGrpIdLastEdit = this.$session.get('UserInfo').tblUserGrpId
                    this.$store.state.OldDataForLog = JSON.stringify(this.DataAxios)
                } else {
                    this.Status = 'Add'
                    this.DataAxios.PersonnelId = this.$route.params.DataRow.id
                    this.DataAxios.TblUserGrpIdInsert = this.$session.get('UserInfo').tblUserGrpId
                }
            }
        })
    }
}
</script>
<style scoped>
tr {
    color: var(--sidebar-color-item) !important;
}

table {
    background: var(--sidebar-bg-color) !important;
    color: var(--sidebar-color-item);
}

td {
    border-color: var(--table-border-color) !important;
}

th {
    font-weight: normal;
    text-align: center;
    font-size: 12px;
    color: var(--sidebar-color-item) !important;
    border-color: var(--table-border-color) !important;
}

thead {
    border-color: var(--table-border-color) !important;
}

tr:hover {
    color: var(--sidebar-color-item) !important;
    background: var(--sidebar-bg-color) !important;
}
</style>